module.exports = __webpack_public_path__ + "static/img/2-2.22c8936.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/毕业照/2-2.jpg
// module id = DNIL
// module chunks = 0